<template>
  <v-layout align-center column fill-height pt-3 >
    <h1 class="font-weight-regular text-xs-center">Não encontrado!</h1>
    <h2 class="font-weight-light text-xs-center">Não foi possível encontrar o responsável.</h2>
    <v-layout align-center column @click="redirectToQrcode" mt-3>
      <QrCode size="80"/>
      <h3 class="font-weight-regular text-xs-center">Tente novamente</h3>
    </v-layout>
  </v-layout>
</template>

<script>
import QrCode from '@/components/icons/QrCode'

export default {
  components: {
    QrCode
  },

  methods: {
    redirectToQrcode () {
      this.$router.push('/qr')
    }
  }
}
</script>
